import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a3988b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title container-title" }, "员工查询", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "block-search" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 姓名或身份证： ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 保单状态： ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 被派遣单位： ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "operations" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "alert-block" }
const _hoisted_14 = { class: "block-head" }
const _hoisted_15 = {
  key: 0,
  class: "tyoe"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 保障中 ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "tyoe"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 不在保 ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "name" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_25 = { class: "idcard" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "身份证：", -1))
const _hoisted_27 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_alertBox = _resolveComponent("alertBox")!
  const _component_change_company = _resolveComponent("change-company")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            placeholder: "请输入姓名或身份证"
          }, null, 8, ["modelValue"]),
          _hoisted_6,
          _createVNode(_component_el_select, {
            modelValue: _ctx.onlyActive,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.onlyActive) = $event)),
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "全部",
                value: "0"
              }),
              _createVNode(_component_el_option, {
                label: "在保",
                value: "1"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_7,
          _createVNode(_component_el_autocomplete, {
            "fetch-suggestions": _ctx.patchAuto,
            class: "form-value",
            modelValue: _ctx.companyText,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyText) = $event)),
            placeholder: "请选择被派遣单位",
            onSelect: _ctx.selectPatch
          }, null, 8, ["fetch-suggestions", "modelValue", "onSelect"]),
          _createElementVNode("button", {
            class: "mini-btn btn-alone",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "查询")
        ]),
        _createElementVNode("button", {
          class: "mini-btn",
          style: {"height":"32px"},
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportEmployee && _ctx.exportEmployee(...args)))
        }, "导出")
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              fixed: "",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              "column-key": "date",
              fixed: "",
              width: "90",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass(scope.row.status == '保障中'?'dot dot-green':'dot dot-red')
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(scope.row.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              width: "80",
              fixed: "",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "idcard",
              width: "170",
              label: "身份证号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "plan_name",
              label: "方案类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "company_name",
              width: "180",
              label: "被派遣单位"
            }),
            _createVNode(_component_el_table_column, {
              formatter: 
              (item) =>
                item.occupation_name +
                `（${item.occupation_level}类）`
            ,
              label: "所属工种"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "start_date",
              label: "保险起期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "end_date",
              label: "保险止期"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "140",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("span", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.changeCompany(scope.row))
                  }, " 换厂 ", 8, _hoisted_11), [
                    [_vShow, scope.row.is_active]
                  ]),
                  _createElementVNode("span", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.isRecord(scope.row.employee_id))
                  }, " 投保记录 ", 8, _hoisted_12)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _withDirectives(_createVNode(_component_alertBox, {
      dataTitle: "投保记录",
      onClose: _ctx.close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.alertBox.type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22)),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", null, _toDisplayString(_ctx.alertBox.name), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", null, _toDisplayString(_ctx.alertBox.idcard), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_table, {
              data: _ctx.alertBox.table,
              style: {"width":"100%"},
              "header-cell-class-name": "table-head",
              "row-style": { color: '#5E617D' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  fixed: "",
                  label: "序号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "company_name",
                  label: "被派遣单位"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "occupation_name",
                  formatter: 
                (item) =>
                  item.occupation_name +
                  `（${item.occupation_level}类）`
              ,
                  label: "工种"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "plan",
                  label: "方案"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "start_date",
                  label: "开始时间"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("p", null, _toDisplayString(scope.row.start_date.split(' ')[0]), 1),
                    _createElementVNode("p", null, _toDisplayString(scope.row.start_date.split(' ')[1]), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "end_date",
                  label: "结束时间"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "create_time",
                  label: "操作时间"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("p", null, _toDisplayString(scope.row.create_time.split(' ')[0]), 1),
                    _createElementVNode("p", null, _toDisplayString(scope.row.create_time.split(' ')[1]), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onClose"]), [
      [_vShow, _ctx.isAlert]
    ]),
    (_ctx.isChangeCompanyAlert)
      ? (_openBlock(), _createBlock(_component_change_company, {
          key: 0,
          row: _ctx.editWorker,
          onClose: _ctx.changeCompanyClose,
          onConfirm: _ctx.changeCompanyConfirm
        }, null, 8, ["row", "onClose", "onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}